import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  Heading,
  IconButton
} from '@walmart-web/livingdesign-components';
import { ChevronLeft } from '@livingdesign/icons';

import styles from './styles.module.css';
import NotificationsPanelBody from '../NotificationsPanelBody/index.tsx';
import { useHistory, useLocation } from 'react-router-dom';
import withFeatureEnabled from '../../../hoc/withFeatureEnabled/index.tsx';
import { NOTIFICATIONS_FEATURE_KEY } from '../../../constants/common.js';
import { logger } from '../../../utils/logger.js';
import InfoBanner from '../../../components/InfoBanner/index.tsx';

type LocationState = {
  state?: {
    from?: string;
  };
};

const MobileNotifications = () => {
  const { t } = useTranslation('profile');
  const location = useLocation() as LocationState;
  const history = useHistory();

  const handleBackClick = () => {
    logger.clickStream('mobile_notifications_back_click', {
      panelistId: localStorage.getItem('panelistId') || ''
    });
    history.push(
      (typeof location.state === 'object' && location.state.from) || '/home'
    );
  };

  return (
    <>
      <InfoBanner enable />
      <Grid UNSAFE_className={styles.mobilePanelHeader}>
        <IconButton
          size="medium"
          a11yLabel="back to notifications button"
          onClick={handleBackClick}
        >
          <ChevronLeft size="medium" />
        </IconButton>
        <Heading size="small">{t('notifications.title')}</Heading>
      </Grid>
      <NotificationsPanelBody mobileView />
    </>
  );
};

export default withFeatureEnabled(
  MobileNotifications,
  NOTIFICATIONS_FEATURE_KEY
);
